import { RiskMethodologyCalculatorMatrix } from './matrix/RiskMethodologyCalculatorMatrix'
import { RiskMethodologyCalculatorMultiply } from './multiply/RiskMethodologyCalculatorMultiply'
import { RiskMethodologyCalculator } from './RiskMethodologyCalculator'

export const RiskMethodologyCalculatorFactory = (riskScoreMethodology?: unknown): RiskMethodologyCalculator => {
  if (riskScoreMethodology === 'MULTIPLY') return RiskMethodologyCalculatorMultiply

  return RiskMethodologyCalculatorMatrix // Default if no methodology is defined
}
